export const ALL_CHANNEL = 'ALL';
export const WEB_CHANNEL = 'WEB';

/** Where a promotion is allowed to apply. */
export const CHANNEL_OPTIONS = [
  { value: ALL_CHANNEL, label: 'All channels' },
  { value: 'POS', label: 'POS' },
  { value: WEB_CHANNEL, label: 'Website' },
];

export const channelDefaultValue = [ALL_CHANNEL];

const labelOf = (channel) =>
  CHANNEL_OPTIONS.find((option) => option.value === channel)?.label || channel;

/** A promotion saved before this field existed applied everywhere. */
export const channelsToFormValue = (channels) => {
  const saved = channels || [];
  return saved.length ? saved : [ALL_CHANNEL];
};

/**
 * All channels cannot be combined with a single one, so picking it drops the
 * rest and picking a named channel drops it. Clearing the last one means
 * everywhere rather than nowhere.
 */
export const selectChannels = (previous, next) => {
  const added = next.filter((channel) => !previous.includes(channel));
  if (!next.length || added.includes(ALL_CHANNEL)) return [ALL_CHANNEL];
  return next.filter((channel) => channel !== ALL_CHANNEL);
};

export const buildChannels = (selected) => {
  const picked = selected || [];
  const named = picked.filter((channel) => channel !== ALL_CHANNEL);
  return picked.includes(ALL_CHANNEL) || !named.length
    ? [ALL_CHANNEL]
    : named;
};

export const describeChannels = (channels) =>
  channelsToFormValue(channels).map(labelOf).join(', ');
